import { useState } from 'react'

export function useHeader() {
  const [currentHover, setCurrentHover] = useState('')
  const handleHover = (index: string) => {
    setCurrentHover(index)
  }
  const handleLeave = () => {
    setCurrentHover('')
  }
  return {
    currentHover,
    handleHover,
    handleLeave,
  }
}
